export function formatUnixTimestamp(unixTimestamp) {
    const date = new Date(unixTimestamp);

    const localDate = new Date(date.toLocaleString('en-US', { timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone }));

    const today = new Date();
    const isToday = localDate.getDate() === today.getDate() &&
                    localDate.getMonth() === today.getMonth() &&
                    localDate.getFullYear() === today.getFullYear();

    const formatTime = (date) => {
        let hours = date.getHours();
        const minutes = date.getMinutes().toString().padStart(2, '0');
        const ampm = hours >= 12 ? 'PM' : 'AM';
        hours = hours % 12 || 12;  // Convert to 12-hour format
        const formattedHours = hours.toString().padStart(2, '0');  // Ensure 2-digit hour format
        return `${formattedHours}:${minutes} ${ampm}`;
    };

    const formatDate = (date) => {
        const day = date.getDate().toString().padStart(2, '0');
        const month = (date.getMonth() + 1).toString().padStart(2, '0'); 
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
    };

    return isToday ? formatTime(localDate) : formatDate(localDate);
}
